import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function CheckoutCancel() {
  useEffect(() => {
    // Track cancelled checkout
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'checkout_cancel',
        ecommerce: {
          checkout_progress: {
            step: 'cancelled'
          }
        }
      });
    }
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="max-w-md w-full mx-auto p-8">
        <div className="bg-white rounded-lg shadow-lg p-6 text-center">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </div>
          
          <h1 className="text-2xl font-bold text-gray-900 mb-4">
            Checkout Cancelled
          </h1>
          
          <p className="text-gray-600 mb-6">
            Your payment was not processed. If you have any questions, please don't hesitate to contact us.
          </p>

          <Link
            to="/"
            className="inline-block bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors"
          >
            Return to Home
          </Link>
        </div>
      </div>
    </div>
  );
}